import type { TracePhase } from './trace-tool-filters';
import { normalizeToolName } from './tool-config.helpers';
import { isSkillFilePath } from './read-file-tool';

const COPILOT_HIDE_ARGS_TOOL_NAMES = new Set([
  'get-endpoint-details',
  'endpoint-details',
  'endpoint-details-tool',
  'get-tracked-endpoint-schema',
  'endpoint-read',
  'search-endpoints',
  'search-tracked-endpoints',
  'get-authentication-details',
  'authentication-details',
  'authentication-details-tool',
  'login-tool',
  'search-tracked-web-pages',
  'list-assets-tool',
]);

export function isCoPilotLabelOnlyLookupTool({
  toolName,
  tracePhase,
  filePath,
}: {
  toolName: string;
  tracePhase: TracePhase;
  filePath?: string;
}): boolean {
  if (tracePhase !== 'co-pilot') {
    return false;
  }

  const normalized = normalizeToolName(toolName);

  return normalized === 'read-file' && isSkillFilePath(filePath);
}

export function shouldShowCoPilotInlineToolArgsPreview({
  toolName,
  tracePhase,
}: {
  toolName: string;
  tracePhase: TracePhase;
}): boolean {
  if (tracePhase !== 'co-pilot') {
    return true;
  }

  const normalized = normalizeToolName(toolName);

  return !COPILOT_HIDE_ARGS_TOOL_NAMES.has(normalized);
}
